import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { vocabularyApi, CreateVocabularyDto, UpdateVocabularyDto, BulkCreateDto } from '../lib/api/vocabulary';

export const VOCABULARY_QUERY_KEY = 'vocabulary';

export function useVocabulary(courseId: number) {
  return useQuery({
    queryKey: [VOCABULARY_QUERY_KEY, courseId],
    queryFn: () => vocabularyApi.getByCourse(courseId),
    enabled: !!courseId,
  });
}

export function useCreateVocabulary() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ courseId, dto }: { courseId: number; dto: CreateVocabularyDto }) =>
      vocabularyApi.create(courseId, dto),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [VOCABULARY_QUERY_KEY, variables.courseId] });
    },
  });
}

export function useUpdateVocabulary() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: UpdateVocabularyDto; courseId: number }) =>
      vocabularyApi.update(id, dto),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [VOCABULARY_QUERY_KEY, variables.courseId] });
    },
  });
}

export function useDeleteVocabulary() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number; courseId: number }) =>
      vocabularyApi.delete(id),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [VOCABULARY_QUERY_KEY, variables.courseId] });
    },
  });
}

export function useBulkCreateVocabulary() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ courseId, dto }: { courseId: number; dto: BulkCreateDto }) =>
      vocabularyApi.bulkCreate(courseId, dto),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [VOCABULARY_QUERY_KEY, variables.courseId] });
    },
  });
}
